import React from 'react';
import { motion } from 'framer-motion';
export function StorySection() {
  return <section className="py-16" data-id="element-164">
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true
    }} className="relative p-8 md:p-12 rounded-3xl bg-gradient-to-br from-brand-card to-brand-dark border border-white/5 overflow-hidden" data-id="element-165">
        <div className="absolute -top-24 -right-24 w-64 h-64 bg-brand-orange/10 rounded-full blur-3xl" data-id="element-166" />
        <div className="absolute -bottom-24 -left-24 w-64 h-64 bg-brand-gold/10 rounded-full blur-3xl" data-id="element-167" />

        <div className="relative z-10 space-y-6 text-lg md:text-xl text-brand-text leading-relaxed font-light" data-id="element-168">
          <p data-id="element-169">
            <span className="text-brand-orange font-medium" data-id="element-170">
              You know the feeling...
            </span>{' '}
            You're working late, the room is dim, and your traditional lamp is
            casting shadows everywhere except where you need them. It's clunky,
            it's ugly, and it takes up half your desk.
          </p>
          <p data-id="element-171">
            We built <strong className="text-white font-bold" data-id="element-172">LumiMate</strong>{' '}
            to break the mold. It's not just a light source; it's an expression
            of creativity.
          </p>
          <p data-id="element-173">
            With industrial-grade suction cups and ultra-flexible limbs, it
            scales your tech, guards your books, and celebrates your wins. It's
            the tool you didn't know you needed, designed to turn a boring desk
            into a sanctuary of focus.
          </p>
        </div>
      </motion.div>
    </section>;
}